// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Photo } from './photo';
import { PurchaseOrderAttachment } from './purchase-order-attachment';
import { PurchaseOrderLine } from './purchase-order-line';
import { PurchaseOrderShipAddress } from './purchase-order-ship-address';
import { PurchaseOrderStatus } from './purchase-order-status';
import { User } from './user';
import { Vendor } from './vendor';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PurchaseOrder extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Statuses = {
        New: 1,
        Ordered: 2,
        Receiving: 3,
        Complete: 4,
        Void: 5,
    };

    static getNextLineNumber(lines: any[]) {
        if (lines.length === 0) return 1;

        let lineNumber: any;
        lineNumber = _.maxBy(lines, 'lineNumber').lineNumber + 1;
        return lineNumber;
    }

    getNextLineNumber() {
        return PurchaseOrder.getNextLineNumber(this.lines);
    }

    get vendorAddressDisplay() {
        if (!this.vendor) return null;
        else
            return `${this.vendor.address1}${this.vendor.address2 ? ' ' + this.vendor.address2 + ' ' : ''} ${this.vendor.city}, ${this.vendor.state} ${this.vendor.postalCode}${
                this.vendor.country ? '  ' + this.vendor.country : ''
            }`;
    }

    get shippingAddressDisplay() {
        return `${!!this.shipToLocation ? this.shipToLocation + ' - ' : ''}${this.shipToAddress1}${this.shipToAddress2 ? ' ' + this.shipToAddress2 + ' ' : ''} ${
            this.shipToCity
        }, ${this.shipToState} ${this.shipToZip}`;
    }

    get statusName() {
        return this.status && this.status.name;
    }

    get subTotal() {
        let subTotal = 0;
        if (!!this.lines) {
            this.lines.forEach((line) => {
                subTotal += line.quantity * line.cost;
            });
        }
        return subTotal;
    }

    _openBalance: number;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  balance!: number;
  completedTimestamp?: Date;
  createDate?: Date;
  createdById?: number;
  deleted?: Date;
  deletedById?: number;
  emailed?: Date;
  estimatedDelivery?: Date;
  freight!: number;
  note?: string;
  pODate?: Date;
  pONumber?: string;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  quickBooksOnlineId?: string;
  quickBooksOnlineLastExport?: Date;
  reportGuid?: string;
  shipCarrier?: string;
  shipToAddress1?: string;
  shipToAddress2?: string;
  shipToCity?: string;
  shipToCompanyName?: string;
  shipToContactName?: string;
  shipToCountry?: string;
  shipToId?: number;
  shipToLocation?: string;
  shipToPhone?: string;
  shipToState?: string;
  shipToZip?: string;
  shippingNote?: string;
  statusId!: number;
  tax!: number;
  terms?: string;
  total!: number;
  vendorId!: number;
  createdBy!: User;
  deletedBy!: User;
  lines!: PurchaseOrderLine[];
  photos!: Photo[];
  purchaseOrderAttachments!: PurchaseOrderAttachment[];
  shipTo!: PurchaseOrderShipAddress;
  status!: PurchaseOrderStatus;
  vendor!: Vendor;
}

